import { __rest, __assign } from '../../node_modules/tslib/tslib.es6.js';
import React__default from 'react';
import Async from '../../node_modules/react-select/async/dist/react-select.esm.js';
import styled from 'styled-components';
import { InputWrapper } from '../input/InputWrapper.js';
import { Label } from '../input/Label.js';
import { Box } from '../layout/Box.js';
import '../layout/Stack.js';
import '../layout/AnimatedBox.js';
import '../layout/Scrollbars.js';
import { selectStyle, formatOptionLabel, DropdownIndicator, MenuList } from './shared.js';
var StyledSelect = styled(Async)(selectStyle);
var AsyncSelect = React__default.forwardRef(function (_a, ref) {
  _a.theme;
  var onFocus = _a.onFocus,
    onBlur = _a.onBlur,
    onChange = _a.onChange,
    label = _a.label,
    isInvalid = _a.isInvalid,
    isDisabled = _a.isDisabled,
    rest = __rest(_a, ["theme", "onFocus", "onBlur", "onChange", "label", "isInvalid", "isDisabled"]);
  var defaultValue = rest.defaultValue,
    value = rest.value,
    backgroundColor = rest.backgroundColor;
  var _b = React__default.useState(false),
    isFocused = _b[0],
    setIsFocused = _b[1];
  var _c = React__default.useState(false),
    hasValue = _c[0],
    setHasValue = _c[1];
  React__default.useEffect(function () {
    if (defaultValue || value) {
      setHasValue(true);
    }
  }, [defaultValue, value]);
  var handleFocus = function handleFocus(e) {
    setIsFocused(true);
    onFocus === null || onFocus === void 0 ? void 0 : onFocus(e);
  };
  var handleBlur = function handleBlur(e) {
    setIsFocused(false);
    onBlur === null || onBlur === void 0 ? void 0 : onBlur(e);
  };
  var handleChange = function handleChange(val, action) {
    if (val) {
      setHasValue(true);
    } else {
      setHasValue(false);
    }
    onChange === null || onChange === void 0 ? void 0 : onChange(val, action);
  };
  return React__default.createElement(InputWrapper, {
    as: "label",
    backgroundColor: backgroundColor || "base",
    isFocused: isFocused,
    isInvalid: isInvalid,
    isDisabled: isDisabled,
    position: "relative"
  }, React__default.createElement(Box, {
    paddingY: "8px"
  }, React__default.createElement(Label, {
    marginTop: "-20px",
    isFocused: isFocused,
    hasValue: hasValue,
    isDisabled: isDisabled,
    isInvalid: isInvalid
  }, label), React__default.createElement(Box, {
    position: "absolute",
    top: "0",
    left: "0",
    width: "100%",
    height: "100%"
  }, React__default.createElement(StyledSelect, __assign({
    placeholder: "",
    formatOptionLabel: formatOptionLabel,
    components: {
      DropdownIndicator: DropdownIndicator,
      MenuList: MenuList
    }
  }, rest, {
    classNamePrefix: "react-select",
    onFocus: handleFocus,
    onBlur: handleBlur,
    onChange: handleChange,
    ref: ref
  })))));
});
export { AsyncSelect };